import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { Constants, TP_REDEMPTION_RATE } from "../../../@types/Constants";
import { useAppDispatch, useAppSelector } from "../../../hooks";
import {
  cancelReservation,
  crmBasicProfileSelector,
  updateRequestStatus,
} from "../../../redux/slices/Member/member";
import ErrorMessageAlert from "../ErrorMessageAlert/ErrorMessageAlert";
import { StyledDialog } from "./ReservationCancelDialogHelpers";
import { IReservationCancelDialogProps } from "./ReservationCancelDialogProps";

const ReservationCancelDialog: React.FC<IReservationCancelDialogProps> = ({
  config,
  onHide,
}) => {
  const dispatch = useAppDispatch();
  const reqStatus = useAppSelector((state) => {
    const reqStatus: any = state.member.updateRequestStatus;
    const retObj: any = {};
    if (reqStatus && reqStatus.type === "cancel-reservation") {
      retObj.status = reqStatus.status;
      retObj.cancelID = reqStatus.cancelID;
    }
    return retObj;
  });
  const [inProgress, setInProgress] = useState(false);
  const [readTerms, setReadTerms] = useState(false);

  const reservation: any = config.res;
  const hotel: any | null = reservation ? reservation.hotel_details : null;
  const renderTooltip = (props: any) => (
    <Tooltip id="cancelPolicy" {...props}>
      {reservation.cancelPolicies.Description ||
        reservation.cancelPolicies.description}
    </Tooltip>
  );

  const TermsAndPolicies = () => {
    return (
      <OverlayTrigger
        placement="top"
        delay={{ show: 250, hide: 400 }}
        overlay={renderTooltip}
      >
        <span>Terms and Policies</span>
      </OverlayTrigger>
    );
  };

  const handleOnReadTerms = (e: any) => {
    setReadTerms(e.target.checked);
  };

  const crmBasicProfile = useAppSelector(crmBasicProfileSelector);
  const { memberLastName, memberId } = crmBasicProfile;

  const onConfirm = () => {
    setInProgress(true);
    if (reservation && reservation?.crs_reservation_id) {
      let isRedemptionRate = false;

      if (
        TP_REDEMPTION_RATE.includes(reservation?.details?.ratePlanCode) ||
        reservation?.redeemedPoints > 0
      ) {
        isRedemptionRate = true;
      }

      dispatch(
        cancelReservation({
          resId: reservation?.crs_reservation_id,
          hotelCode: hotel
            ? hotel.crs_code
            : reservation.details
            ? reservation.details.HotelCode
            : null,
          lastName: memberLastName,
          memberId: memberId,
          isRedemption: isRedemptionRate,
        })
      );
    } else {
      console.error("reservation is null or crs_reservation_id is undefined");
    }
  };

  const onClose = () => {
    dispatch(updateRequestStatus({}));
    setInProgress(false);
    setReadTerms(false);
    onHide(reqStatus);
  };

  return (
    <StyledDialog
      show={config.openDialog}
      onHide={onClose}
      centered
      backdrop={
        inProgress &&
        (!reqStatus ||
          (reqStatus.status !== "success" && reqStatus.status !== "error"))
          ? "static"
          : true
      }
      keyboard={false}
      size="lg"
      aria-label="Reservation Confirmation"
    >
      <Modal.Header closeButton />
      {/* <CloseButton aria-label="Hide" onClick={onClose}/> */}
      <Modal.Body>
        {reqStatus && reqStatus.status === "success" && (
          <p className="text-success">
            Your reservation has been successfully cancelled.
          </p>
        )}
        {reqStatus && reqStatus.status === "error" && (
          <ErrorMessageAlert
            errorType={Constants.ERRORSTYPE.RESERVATION}
            errorSubType={Constants.ERRORSSUBTYPE.RESRVATION.CANCEL}
            message={`Reservation can not be cancelled -- ${reservation?.crs_reservation_id}`}
          >
            <p className="text-danger">
              We were unable to cancel your reservation.
            </p>
            {hotel && hotel.phone && (
              <p>
                Please contact your hotel at{" "}
                <a
                  className="text-dark error-phone"
                  href={`tel:${hotel.phone}`}
                >
                  {hotel.phone}
                </a>
              </p>
            )}
          </ErrorMessageAlert>
        )}
        {(!reqStatus ||
          (reqStatus.status !== "success" && reqStatus.status !== "error")) && (
          <>
            <h2 className="text-center font-weight-normal">
              Are you sure you want to cancel this reservation?
            </h2>
            <Form.Check onChange={handleOnReadTerms}>
              <Form.Check.Input onChange={handleOnReadTerms} />
              <Form.Check.Label>
                I certify that I read and understand the <TermsAndPolicies /> of
                cancelling this reservation.
              </Form.Check.Label>
            </Form.Check>
            <Button onClick={onConfirm} disabled={inProgress || !readTerms}>
              {inProgress ? "Please wait..." : "Cancel Reservation"}
            </Button>
          </>
        )}
      </Modal.Body>
    </StyledDialog>
  );
};

export default ReservationCancelDialog;
